import CharacterModel from "../model/CharacterModel";

export default class CharacterTrackerEvent {
    /**
     * @constructor
     * @param {string} type 
     * @param {CharacterModel} character 
     * @param {string} trackerId 
     * @param {number} oldValue 
     * @param {number} newValue 
     */
    constructor(type, character, trackerId, oldValue, newValue) {
        this._type = type;
        this._character = character
        this._trackerId = trackerId;
        this._oldValue = oldValue;
        this._newValue = newValue;
    }

    get type() {
        return this._type;
    }

    get character() {
        return this._character;
    }

    get trackerId() {
        return this._trackerId;
    }

    get oldValue() {
        return this._oldValue;
    }

    get newValue() {
        return this._newValue;
    }

    get deltaValue() {
        return this._newValue - this._oldValue;
    }
}

CharacterTrackerEvent.CHANGED = "CharacterTrackerEvent.CHANGED";